var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolidity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_850_3332)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 58,
    fill: "url(#paint0_radial_850_3332)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M80.954 44L71.954 60H53.954L62.954 44H80.954Z",
    fill: "#C1C1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M63.04 100L72.04 84H90.04L81.04 100H63.04Z",
    fill: "#C1C1C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M71.95 60H89.95L80.95 44H62.95L71.95 60Z",
    fill: "#C1C1C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M72.044 84H54.044L63.044 100H81.044L72.044 84Z",
    fill: "#C1C1C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M62.954 76L71.954 60L62.954 44L53.954 60L62.954 76Z",
    fill: "#C1C1C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M81.04 68L72.04 84L81.04 100L90.04 84L81.04 68Z",
    fill: "#C1C1C1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_850_3332",
    x: 0,
    y: 0,
    width: 144,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_850_3332"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_850_3332",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72 72) rotate(85.4261) scale(54.5487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0B0",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidity);
export default __webpack_public_path__ + "static/media/solidity.3ba6c620e4a0eecebc14d364fa3e1324.svg";
export { ForwardRef as ReactComponent };